<template>
  <div>
    <v-snackbar
      absolute
      right
      top
      class="mr-n2"
      v-model="SuccessToast"
      timeout="1500"
      color="primary"
      outlined
    >
      <div class="d-flex justify-space-between">
        <div class="d-flex align-center">
          <v-icon color="primary" size="22"
            >mdi-checkbox-multiple-marked-circle-outline</v-icon
          >
          <span class="mt-n1 ml-5 text_style">{{action === 'add' ? 'Added' : action === 'edit' ? 'Edited' : 'Deleted'}} successfully</span>
        </div>
      </div>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: "SuccessToastComponent",
  props: ["SuccessToast",'action'],
  data() {
    return {};
  },
  mounted() {},
  methods: {
    snackbarClose() {
      this.$emit("close");
    },
  },
};
</script>
